<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: utils.in_rem(8px);

    .left {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      .provider-logo {
        height: 2rem;
        width: 2rem;
        object-fit: contain;
        border-radius: 4px;
        flex-shrink: 0;
      }

      .provider-name {
        font-weight: 500;
        color: var(--sw-grey-90);
        font-size: 1rem;
      }
    }

    .right {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin-left: auto;
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ConfirmNavigation from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/ConfirmNavigation.svelte";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import {
    activeProviderIsErrorStore,
    activeProviderModalStore,
    deactivateIntegration,
  } from "../stores";

  export let onSave;

  let showConfirmation = false;
  let isSaving = false;
  let isDeactivating = false;

  $: isAdmin = $userStore?.isAdmin;
  $: isDemo = $userStore?.userId?.startsWith("demo::");

  $: isButtonDisabled = !isAdmin || isDemo;
  $: isSaveButtonDisabled =
    isButtonDisabled || isSaving || $activeProviderIsErrorStore;
  $: isDeactivateButtonDisabled = isButtonDisabled || isDeactivating;

  const handleDeactivate = async () => {
    if (!$activeProviderModalStore || !isAdmin || isDemo || isDeactivating)
      return;

    try {
      isDeactivating = true;
      await deactivateIntegration($activeProviderModalStore.provider);
      window.location.hash = "";
      window.location.reload();
    } catch {
      isDeactivating = false;
    }
  };

  const confirm = () => {
    handleDeactivate();
  };

  const cancel = () => {
    showConfirmation = false;
  };

  const openConfirmation = () => {
    if (!isAdmin || isDemo || isDeactivating) return;
    showConfirmation = true;
  };

  const handleSave = async () => {
    if (!isAdmin || isDemo || isSaving) return;

    try {
      isSaving = true;
      await onSave();
    } catch {
      isSaving = false;
    }
  };
</script>

<div class="header">
  <div class="left">
    {#if $activeProviderModalStore}
      <img
        class="provider-logo"
        src="/assets/img/crm/{$activeProviderModalStore.provider}.png"
        alt="{$activeProviderModalStore.title} logo"
      />
      <span class="provider-name">{$activeProviderModalStore.title}</span>
    {/if}
  </div>
  <div class="right">
    <Button
      kind="tertiary-grey"
      leadingIcon="fa-link-slash"
      onclick={openConfirmation}
      disabled={isDeactivateButtonDisabled}
      class={isDeactivateButtonDisabled ? "disabled" : ""}
    >
      {isDeactivating ? "Deactivating..." : "Deactivate"}
    </Button>
    <Button
      kind="primary"
      leadingIcon="fa-floppy-disk"
      onclick={handleSave}
      disabled={isSaveButtonDisabled}
      class={isSaveButtonDisabled ? "disabled" : ""}
    >
      {isSaving ? "Saving..." : "Save"}
    </Button>
  </div>
</div>

{#if showConfirmation}
  <ConfirmNavigation {confirm} {cancel}>
    <div slot="header">
      <h2>Deactivate Integration</h2>
    </div>
    Are you sure you want to deactivate the {$activeProviderModalStore.title} integration
    for your entire team?
  </ConfirmNavigation>
{/if}
